module.exports = __webpack_public_path__ + "static/media/LoginBackgroundImage.304c6da7.png";